<template>
  <!--
    « Affichage » — the per-page table settings, in the Fondation's standard dialog.

    It used to be two surfaces: a bottom sheet on a phone, and on desktop a `v-menu` holding a
    draggable card — a non-modal palette one could shove aside to watch the table change
    underneath. One dialog replaces both. The panel carries its own live preview, which is what
    the palette was really for: seeing a setting take effect without hunting for it in the sheet
    behind. What the palette cost in exchange — a bespoke drag composable, a `role="dialog"` menu,
    `pointer-events` juggling so the anchored content box stopped swallowing clicks, and a dialog
    that behaved like nothing else in the app — is what this drops.
  -->
  <BaseDialog v-model="open" :title="translate('parcours.teaching.density.title')"
    :subtitle="translate('parcours.teaching.density.subtitle')"
    icon="fa-sliders" :max-width="DIALOG_WIDTH.standard">
    <template #activator="{ props }">
      <v-btn v-bind="props" class="teaching-density-control" variant="text" color="primary" icon
        size="32" :aria-label="translate('parcours.teaching.density.ariaLabel')">
        <v-icon size="16">fa-sliders</v-icon>
        <v-tooltip activator="parent" location="bottom" :disabled="open">{{ translate('parcours.teaching.density.tooltip') }}</v-tooltip>
      </v-btn>
    </template>
    <TeachingGridAppearancePanel />
    <template #actions>
      <v-btn color="primary" variant="flat" @click="open = false">{{ translate('parcours.teaching.density.done') }}</v-btn>
    </template>
  </BaseDialog>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { translate } from '@fondationcss/sdk';
import { BaseDialog } from '@fondationcss/ui';
import { DIALOG_WIDTH } from '@/utils/dialog-width';
import TeachingGridAppearancePanel from './teaching-grid-appearance-panel.vue';

const open = ref(false);
</script>

<style scoped>
.teaching-density-control { flex: 0 0 auto; }
</style>
